import React from "react"
import { createRoot } from "react-dom/client"
import { unmountComponentAtNode } from "react-dom"
import ModalInfoCentered from "./ModalInfoCentered"
import { modalInfoCenteredState } from "./store"

/**
 * @param {Object} props
 * @param {Object} props.phrases - Modal phrases
 * @param {string} props.phrases.title - Modal title
 * @param {string} props.phrases.description - Modal text
 * @param {string} props.phrases.button - Modal button text
 * @param {Function} props.onClick - Modal button click handler
 * @param {Array} props.buttons - Modal buttons
 * @param {Function} props.onClose - Modal close handler
 * @param {React.ReactNode} props.children - Modal content
 * @returns {void}
 */
let root = null

export const renderModalInfoCentered = ({
  phrases,
  onClick,
  buttons,
  children,
  onClose,
}) => {
  const body = document.querySelector("body")
  let rootElement = document.querySelector(".js_modal_info_centered_root")

  if (!rootElement) {
    rootElement = document.createElement("div")
    rootElement.classList.add("js_modal_info_centered_root")
    body.appendChild(rootElement)
    root = createRoot(rootElement)
  }

  const handleClose = () => {
    onClose?.()
    setTimeout(() => {
      // unmountComponentAtNode(rootElement)
      root.unmount()
      rootElement.remove()
      root = null
    }, 300)
  }

  root.render(
    <ModalInfoCentered
      phrases={modalInfoCenteredState.getValue().phrases}
      onClick={onClick}
      setIsModalOpen={(state) => {
        if (!state) {
          handleClose()
        }
      }}
      buttons={buttons}
    >
      {children}
    </ModalInfoCentered>,
  )
}

export default ModalInfoCentered
